export enum ModalEventTypes {
  Opened = 'opened',
  Closed = 'closed',
  Dismissed = 'dismissed',
  ManualClosed = 'manual-closed',
  Confirmed = 'confirmed',
  Canceled = 'canceled',
  Submitted = 'submitted',
}

export enum ModalClosedEventTypes {
  ManualClosed = 'manual-closed',
  Dismissed = 'dismissed',
  Canceled = 'canceled',
  Confirmed = 'confirmed',
  Closed = 'closed',
}
